import DefaultLayout, { LayoutComponent, LayoutProps } from '../Components/Layout.js';

/**
 * Layout capability
 */
export const Default = DefaultLayout;
export type Component = LayoutComponent;
export type Props = LayoutProps;